<template>
  <div class="temporary-pay">
    <div class="search">
      <div class="search-left">
        <div class="search-left-content">
          <el-select
            @change="getServiceCompanyList"
            v-model="warehouseId"
            clearable
            class="gray"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select v-model="serviceCompanyId" clearable class="gray" placeholder="请选择劳务公司">
            <el-option
              v-for="item in searchServiceCompanyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            class="gray"
            v-model="date"
            type="date"
            :clearable="false"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
          <el-input class="gray" v-model="name" placeholder="请输入姓名"></el-input>
          <el-button class="btn-blue" @click="searchData">搜索</el-button>
          <el-button class="btn-blue" @click="clearData">清空</el-button>
        </div>
        <div class="search-left-btns">
          <el-button class="btn-blue" @click="exportExcel">导出</el-button>
          <el-button class="btn-blue" @click="openServiceCompanyDialog">规则设定</el-button>
        </div>
      </div>
      <div class="search-right"></div>
    </div>
    <div class="table">
      <div class="totle-price">
        <p>
          <span>合计(元)：</span>
          <span>{{ totalCost }}</span>
        </p>
        <el-button class="btn-text" type="text" @click="getTotalCostRefresh">重新计算</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="员工" min-width="75">
          <template slot-scope="scope">
            <el-input class="white" v-model="scope.row.name"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="hourSalary" label="时薪" min-width="65"></el-table-column>
        <el-table-column prop="type" label="工种" min-width="90">
          <template slot-scope="scope">
            <el-select
              @change="changeLaborType(scope.$index)"
              v-model="scope.row.type"
              class="white"
            >
              <el-option
                v-for="item in laborList"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="departmentId" label="所属部门" min-width="90">
          <template slot-scope="scope">
            <el-select v-model="scope.row.departmentId" class="white">
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="上班时间" width="95">
          <template slot-scope="scope">
            <span>{{scope.row.startTime}}</span>
            <svg
              v-if="scope.row.startTime&& scope.row.startCheck===0"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2124"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M508.2 890.07c-209.42 0-379.8-170.38-379.8-379.8s170.38-379.8 379.8-379.8S888 300.85 888 510.27s-170.38 379.8-379.8 379.8z m0-708.95c-181.5 0-329.16 147.65-329.16 329.16S326.69 839.44 508.2 839.44s329.16-147.65 329.16-329.16S689.7 181.12 508.2 181.12z"
                fill="#d81e06"
                p-id="2125"
              />
              <path
                d="M508.2 636.88c-13.93 0-25.67-6.36-26.1-14.37l-17.5-321.82c-1.27-23.41 18.32-43.6 43.6-43.6 25.29 0 44.88 20.19 43.6 43.6L534.3 622.5c-0.44 8.02-12.18 14.38-26.1 14.38z"
                fill="#d81e06"
                p-id="2126"
              />
              <path
                d="M508.2 712.84m-50.64 0a50.64 50.64 0 1 0 101.28 0 50.64 50.64 0 1 0-101.28 0Z"
                fill="#d81e06"
                p-id="2127"
              />
            </svg>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="下班时间" width="95">
          <template slot-scope="scope">
            <span>{{scope.row.endTime}}</span>
            <svg
              v-if="scope.row.endTime &&scope.row.endCheck===0"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2124"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M508.2 890.07c-209.42 0-379.8-170.38-379.8-379.8s170.38-379.8 379.8-379.8S888 300.85 888 510.27s-170.38 379.8-379.8 379.8z m0-708.95c-181.5 0-329.16 147.65-329.16 329.16S326.69 839.44 508.2 839.44s329.16-147.65 329.16-329.16S689.7 181.12 508.2 181.12z"
                fill="#d81e06"
                p-id="2125"
              />
              <path
                d="M508.2 636.88c-13.93 0-25.67-6.36-26.1-14.37l-17.5-321.82c-1.27-23.41 18.32-43.6 43.6-43.6 25.29 0 44.88 20.19 43.6 43.6L534.3 622.5c-0.44 8.02-12.18 14.38-26.1 14.38z"
                fill="#d81e06"
                p-id="2126"
              />
              <path
                d="M508.2 712.84m-50.64 0a50.64 50.64 0 1 0 101.28 0 50.64 50.64 0 1 0-101.28 0Z"
                fill="#d81e06"
                p-id="2127"
              />
            </svg>
          </template>
        </el-table-column>
        <el-table-column prop="hours" label="工时" min-width="80">
          <template slot-scope="scope">
            <el-input class="white" v-model="scope.row.hours"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="meal" label="餐费" min-width="80">
          <template slot-scope="scope">
            <el-input class="white" v-model="scope.row.meal"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="rewardPunishment" label="奖惩" min-width="80">
          <template slot-scope="scope">
            <el-input class="white" v-model="scope.row.rewardPunishment"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="laborSalary" label="当日工费" min-width="85"></el-table-column>
        <el-table-column prop="laborCost" label="实际支出" min-width="85"></el-table-column>
        <el-table-column prop="remarks" label="备注" min-width="160">
          <template slot-scope="scope">
            <p class="remarks">{{ scope.row.remarks }}</p>
            <svg
              @click="openRemarkDialog(scope.row)"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3331"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M843.294118 1024H145.568627c-75.294118 0-135.529412-60.235294-135.529411-135.529412V195.764706c0-75.294118 60.235294-135.529412 135.529411-135.529412h346.352942c30.117647 0 50.196078 20.078431 50.196078 50.196079s-20.078431 50.196078-50.196078 50.196078H145.568627c-20.078431-5.019608-35.137255 15.058824-35.137254 35.137255v692.705882c0 20.078431 15.058824 35.137255 35.137254 35.137255h692.705883c20.078431 0 35.137255-15.058824 35.137255-35.137255v-346.352941c0-30.117647 20.078431-50.196078 50.196078-50.196078s50.196078 20.078431 50.196079 50.196078v346.352941c5.019608 75.294118-55.215686 135.529412-130.509804 135.529412z"
                fill="#2E68EA"
                p-id="3332"
              />
              <path
                d="M501.960784 562.196078c-15.058824 0-25.098039-5.019608-35.137255-15.058823-20.078431-20.078431-20.078431-50.196078 0-70.27451L928.627451 15.058824c20.078431-20.078431 50.196078-20.078431 70.27451 0s20.078431 50.196078 0 70.274509l-461.803922 461.803922c-10.039216 10.039216-20.078431 15.058824-35.137255 15.058823z"
                fill="#2E68EA"
                p-id="3333"
              />
            </svg>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="105">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="updateData(scope.row)">保存</el-button>
            <el-button class="btn-text" type="text" @click="openTemporaryDialog(scope.row)">移动</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
    <!-- 规则设定 -->
    <el-dialog title="规则设定" top="25vh" :visible.sync="serviceCompanyDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="serviceCompanyForm"
        :rules="serviceCompanyFormRules"
        :model="serviceCompanyForm"
        label-width="120px"
      >
        <el-form-item label="劳务公司：" prop="name">
          <el-select
            @change="getServiceCompanyForm"
            v-model="serviceCompanyForm.name"
            clearable
            class="gray"
            placeholder="请选择劳务公司"
          >
            <el-option
              v-for="item in serviceCompanyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上班时间：" prop="time">
          <el-time-select
            class="gray"
            v-model="serviceCompanyForm.time"
            :picker-options="{
              start: '07:00',
              step: '00:15',
              end: '12:00'
            }"
            placeholder="选择时间"
          ></el-time-select>
        </el-form-item>
        <el-form-item label="周期工时薪：" prop="periodicPrice">
          <el-input class="gray" v-model="serviceCompanyForm.periodicPrice" placeholder="请输入周期工时薪"></el-input>
        </el-form-item>
        <el-form-item label="临时工时薪：" prop="temporaryPrice">
          <el-input class="gray" v-model="serviceCompanyForm.temporaryPrice" placeholder="请输入临时工时薪"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submitServiceCompany('serviceCompanyForm')">确定</el-button>
      </div>
    </el-dialog>
    <!-- 临时工移动 -->
    <el-dialog title="临时工移动" top="25vh" :visible.sync="temporaryDialog" width="420px">
      <div class="border"></div>
      <el-form ref="temporaryForm" :model="temporaryForm" label-width="100px">
        <el-form-item label="员工姓名：" prop="name">
          <el-input class="gray" v-model="temporaryForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="劳务公司：" prop="companyId">
          <el-select v-model="temporaryForm.companyId" class="gray" placeholder="选择所属劳务公司">
            <el-option
              v-for="item in serviceCompanyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工种：" prop="type">
          <el-select v-model="temporaryForm.type" class="gray" placeholder="请选择工种">
            <el-option
              v-for="item in laborList"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submitTempMove">确定</el-button>
      </div>
    </el-dialog>
    <!-- 备注编辑 -->
    <el-dialog title="备注编辑" top="25vh" :visible.sync="remarkDialog" width="420px">
      <div class="border"></div>
      <el-form ref="remarkForm" :model="remarkForm" label-width="80px">
        <el-form-item label="备注：" prop="remark">
          <el-input
            type="textarea"
            class="gray"
            :autosize="{ minRows: 2, maxRows: 5 }"
            v-model="remarkForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submitRemark">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDecimal, formaTimeToSecond, modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
import Temporary from "models/temporary";
import Employee from "models/employee";
const expenses = new Expenses();
const temporary = new Temporary();
const employee = new Employee();
export default {
  data() {
    return {
      warehouseId: "",
      serviceCompanyId: "",
      date: "",
      name: "",
      searchForm: {
        warehouseId: "",
        serviceCompanyId: "",
        date: "",
        name: ""
      },
      warehouseList: [],
      searchServiceCompanyList: [],
      serviceCompanyList: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      totalCost: 0,
      //规则设定
      serviceCompanyDialog: false,
      serviceCompanyForm: {
        name: "",
        time: "",
        periodicPrice: "",
        temporaryPrice: ""
      },
      serviceCompanyFormRules: {
        name: [{ required: true, message: "选择劳务公司", trigger: "change" }],
        time: [{ required: true, message: "请选择时间点", trigger: "change" }],
        periodicPrice: [
          { required: true, message: "请输入周期工时薪", trigger: "blur" }
        ],
        temporaryPrice: [
          { required: true, message: "请输入临时工时薪", trigger: "blur" }
        ]
      },
      //临时工移动
      temporaryDialog: false,
      temporaryForm: {
        id: "",
        name: "",
        companyId: "",
        type: ""
      },
      laborList: [
        {
          type: 1,
          name: "周期工"
        },
        {
          type: 2,
          name: "临时工"
        }
      ],
      //部门列表
      departmentList: [],
      //备注编辑
      remarkDialog: false,
      remarkForm: {
        id: "",
        remark: ""
      }
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('临时工支出')
    this.getWarehouseList();
    this.getServiceCompany();
    this.getTableData();
  },
  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    //获取劳务公司数据
    getServiceCompany() {
      let warehouseId = this.warehouseId;
      temporary.getTempLaborList(warehouseId).then(res => {
        if (res.success) {
          let serviceCompanyList = [];
          let searchServiceCompanyList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.startTime = value.startTime;
            obj.periodicPrice = "";
            obj.temporaryPrice = "";
            value.laborRuleList.map(v => {
              if (v.type === 1) {
                obj.periodicPrice = v.hourSalary;
              } else if (v.type === 2) {
                obj.temporaryPrice = v.hourSalary;
              }
            });
            serviceCompanyList.push(obj);
            searchServiceCompanyList.push(obj);
          });
          if (this.serviceCompanyList.length === 0) {
            this.serviceCompanyList = serviceCompanyList;
          } else {
            this.searchServiceCompanyList = searchServiceCompanyList;
          }
        }
      });
    },
    getServiceCompanyList(id) {
      this.serviceCompanyId = "";
      if (id) {
        this.getServiceCompany();
      } else {
        this.searchServiceCompanyList = [];
      }
    },
    //获取部门数据
    getCompanyList() {
      let warehouseId = this.searchForm.warehouseId;
      employee.getDeptList(warehouseId).then(res => {
        let departmentList = [];
        if (res.success) {
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            departmentList.push(obj);
          });
          this.departmentList = departmentList;
          this.getTableData();
        }
      });
    },
    //获取表格数据
    getTableData() {
      let warehouseId = this.searchForm.warehouseId;
      let laborId = this.searchForm.serviceCompanyId;
      let date = this.searchForm.date;
      let name = this.searchForm.name;
      let currentPage = this.currentPage;
      temporary
        .getTempList(warehouseId, laborId, date, name, currentPage)
        .then(res => {
          if (res.success) {
            this.total = res.result.totalNum;
            this.totalCost = res.result.totalCost;
            let tableData = [];
            res.result.items.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.name = value.name;
              obj.departmentId =
                value.departmentId === 0 ? "" : value.departmentId;
              obj.laborRuleList = value.laborRuleList;
              obj.laborRuleId = value.laborRuleId;
              obj.laborId = value.laborId;
              obj.startTime = value.startTime
                ? formaTimeToSecond(value.startTime)
                : "";
              obj.endTime = value.endTime
                ? formaTimeToSecond(value.endTime)
                : "";
              obj.startCheck = value.startCheck;
              obj.endCheck = value.endCheck;
              obj.hours = value.hours;
              obj.meal = value.meal;
              obj.rewardPunishment = value.rewardPunishment;
              obj.laborSalary = value.laborSalary;
              obj.laborCost = value.laborCost;
              obj.remarks = value.remarks;
              value.laborRuleList.map(v => {
                if (v.id === value.laborRuleId) {
                  obj.type = v.type;
                  obj.hourSalary = v.hourSalary;
                }
              });
              tableData.push(obj);
            });
            this.tableData = tableData;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    //搜索
    searchData() {
      if (this.date && this.warehouseId && this.serviceCompanyId) {
        this.searchForm.warehouseId = this.warehouseId;
        this.searchForm.serviceCompanyId = this.serviceCompanyId;
        this.searchForm.date = this.date;
        this.searchForm.name = this.name;
        this.currentPage = 1;
        this.getCompanyList();
      } else {
        this.$message.error("请先选择仓库、劳务公司或日期");
      }
    },
    clearData() {
      this.warehouseId = "";
      this.serviceCompanyId = "";
      this.date = "";
      this.name = "";
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    //修改工种
    changeLaborType(index) {
      let laborRuleList = this.tableData[index].laborRuleList;
      let hourSalary = "";
      let type = this.tableData[index].type;
      let laborRuleId = "";
      laborRuleList.map(value => {
        if (value.type === type) {
          hourSalary = value.hourSalary;
          laborRuleId = value.id;
        }
      });
      this.tableData[index].hourSalary = hourSalary;
      this.tableData[index].laborRuleId = laborRuleId;
    },
    //显示规则设定
    openServiceCompanyDialog() {
      this.serviceCompanyDialog = true;
    },
    //显示移动
    openTemporaryDialog(row) {
      this.temporaryDialog = true;
      this.temporaryForm.id = row.id;
      this.temporaryForm.name = row.name;
      this.temporaryForm.companyId = row.laborId;
      this.temporaryForm.type = row.type;
    },
    //显示备注弹窗
    openRemarkDialog(row) {
      this.remarkDialog = true;
      this.remarkForm.id = row.id;
      this.remarkForm.remark = row.remarks;
    },
    //关闭弹窗
    closeDialog() {
      this.serviceCompanyDialog = false;
      this.temporaryDialog = false;
      this.remarkDialog = false;
      if (this.$refs["serviceCompanyForm"]) {
        this.$refs["serviceCompanyForm"].resetFields();
      }
    },
    //保存规则设定
    submitServiceCompany(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.serviceCompanyForm);
          let data = {};
          data.laborId = this.serviceCompanyForm.name;
          data.startTime = this.serviceCompanyForm.time;
          data.cycleSalary = this.serviceCompanyForm.periodicPrice;
          data.tempSalary = this.serviceCompanyForm.temporaryPrice;
          temporary.postUpdateTempLabor(data).then(res => {
            if (res.success) {
              this.$message.success("规则设定成功");
              this.closeDialog();
              let warehouseId = "";
              temporary.getTempLaborList(warehouseId).then(res => {
                if (res.success) {
                  let serviceCompanyList = [];
                  res.result.map(value => {
                    let obj = {};
                    obj.id = value.id;
                    obj.name = value.name;
                    obj.startTime = value.startTime;
                    obj.periodicPrice = "";
                    obj.temporaryPrice = "";
                    value.laborRuleList.map(v => {
                      if (v.type === 1) {
                        obj.periodicPrice = v.hourSalary;
                      } else if (v.type === 2) {
                        obj.temporaryPrice = v.hourSalary;
                      }
                    });
                    serviceCompanyList.push(obj);
                  });
                  this.serviceCompanyList = serviceCompanyList;
                }
              });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //保存备注
    submitRemark() {
      this.tableData.map(value => {
        if (value.id === this.remarkForm.id) {
          value.remarks = this.remarkForm.remark;
          this.closeDialog();
        }
      });
    },
    //保存临时工移动
    submitTempMove() {
      let data = {};
      data.id = this.temporaryForm.id;
      data.laborId = this.temporaryForm.companyId;
      data.type = this.temporaryForm.type;
      temporary.postMoveTemp(data).then(res => {
        if (res.success) {
          this.closeDialog();
          this.getTableData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //保存整条数据
    updateData(row) {
      let data = {};
      data.id = row.id;
      data.name = row.name;
      data.laborRuleId = row.laborRuleId;
      data.departmentId = row.departmentId;
      data.hours = row.hours;
      data.meal = row.meal;
      data.rewardPunishment = row.rewardPunishment;
      data.remarks = row.remarks;
      temporary.postUpdateTemp(data).then(res => {
        if (res.success) {
          this.getTableData();
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //重新计算
    getTotalCostRefresh() {
      if (this.date) {
        let data = {
          date: this.date
        };
        temporary.postTempCalculate(data).then(res => {
          if (res.success) {
            this.$message({
              message: "计算成功",
              type: "success",
              duration: 1000
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
              duration: 3000
            });
          }
        });
      } else {
        this.$message.error("请选择日期");
      }
    },
    getServiceCompanyForm(id) {
      console.log(id);
      if (id) {
        this.serviceCompanyList.map(value => {
          if (value.id === id) {
            console.log(value);
            this.serviceCompanyForm.name = value.id;
            this.serviceCompanyForm.time = value.startTime;
            this.serviceCompanyForm.periodicPrice = value.periodicPrice;
            this.serviceCompanyForm.temporaryPrice = value.temporaryPrice;
          }
        });
      }
    },
    // 导出表格
    exportExcel() {
      if (this.tableData.length > 0) {
        let warehouseId = this.searchForm.warehouseId;
        let laborId = this.searchForm.serviceCompanyId;
        let date = this.searchForm.date;
        let name = this.searchForm.name;
        temporary.getExportExcel(warehouseId, laborId, date, name).then(res => {
          let blob = new Blob([res.data], { type: res.headers.contentType });
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          var url = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          // 释放之前创建的URL对象
          window.URL.revokeObjectURL(url);
        });
      } else {
        this.$message.error("搜索数据为空，请重新搜索");
      }
    },
    //限制考勤输入
    inputDescSalary(index, price) {
      let descSalary = getDecimal(price);
      this.tableData[index].descSalary = descSalary;
    }
  }
};
</script>
<style lang="scss" scoped>
.temporary-pay {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .search-left-content {
      margin-bottom: 16px;
      .el-input {
        width: 200px;
        margin-right: 16px;
      }
    }
    .el-select {
      margin-right: 16px;
    }
    .btn-blue {
      margin: 0;
      margin-right: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .totle-price {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .btn-text {
        margin-left: 16px;
      }
    }
    .el-table {
      .cell {
        position: relative;
        .remarks {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 14px;
        }
        .icon {
          position: absolute;
          right: 1px;
          top: 9px;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .el-dialog {
    .label1 {
      color: #999999;
      padding-bottom: 10px;
    }
    .label2 {
      color: #999999;
      padding-bottom: 16px;
    }
    .el-form {
      padding: 0 30px 0 10px;
      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
      .price {
        display: inline-block;
        position: absolute;
        width: 40px;
        color: #cdcccc;
        right: 0;
      }
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
    .error-message {
      padding-left: 20px;
      padding-bottom: 5px;
      font-size: 12px;
      color: #f56c6c;
    }
  }
}
</style>
<style lang="scss">
.temporary-pay {
  .table {
    .el-table {
      .el-input {
        .el-input__inner {
          height: 24px;

          padding-left: 5px;
          padding-right: 0px;
        }
      }
    }
  }
}
</style>
